import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-24 sm:pt-28 md:pt-32 pb-8 md:pb-16 px-4 md:px-8 max-w-6xl mx-auto" data-id="element-133">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="text-center" data-id="element-134">
        <p className="text-[10px] sm:text-xs md:text-sm uppercase tracking-widest text-burgundy/70 mb-3 md:mb-6 font-lato font-light" data-id="element-135">
          Pour ceux qui refusent d'offrir un cadeau banal cette année.
        </p>

        <h1 className="font-playfair text-[26px] leading-[1.15] sm:text-3xl md:text-5xl lg:text-6xl font-bold text-burgundy mb-3 md:mb-6 px-1" data-id="element-136">
          Le cadeau de chocolaterie de luxe qu'elle ne croira jamais que{' '}
          <span className="italic" data-id="element-137">TU</span> as fait.
        </h1>

        <p className="text-sm sm:text-base md:text-xl text-gray-700 max-w-3xl mx-auto mb-5 md:mb-12 font-lato leading-relaxed px-2" data-id="element-138">
          Crée tes propres fraises au chocolat au rendu Miroir en 10 minutes.
          Pas besoin d'être pâtissière. Accès immédiat.
        </p>

        <motion.div className="mb-6 md:mb-12 rounded-xl md:rounded-2xl overflow-hidden shadow-xl md:shadow-2xl max-w-4xl mx-auto" whileHover={{
        scale: 1.02
      }} transition={{
        duration: 0.3
      }} data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/tTNYPc76jvSvuNHeZuNaUb/SALES_PAGE_IMAGE.png" alt="Boîte cadeau blanche de luxe ouverte sur marbre blanc, contenant 10 fraises artisanales enrobées de chocolat noir, blanc et rose, décorées de feuilles d'or et détails raffinés, avec ruban satin et étiquette Pour Maman" className="w-full h-auto" data-id="element-140" />
        </motion.div>
      </motion.div>
    </section>;
}